// Línea de un bono en el cierre, con el tono de su estado; la usan el de crédito y el Wallet de venta.
import { Gift } from 'lucide-react';
import { formatMXN } from '@/shared/lib/format/money';
import type { PromotionBonusDisplayStatus, PromotionBonusSource } from '../promotionBonusDisplay';
import type { ClosingBonusKind } from '../saleClosing';

/** Quién da el bono: bienvenida o promo de crédito del cierre, o el Wallet de la promo de venta. */
export type PromotionBonusItemKind = ClosingBonusKind | PromotionBonusSource['kind'];

const TONE: Record<PromotionBonusDisplayStatus, { box: string; icon: string }> = {
    PAID: {
        box: 'border-success-soft-border bg-success-soft/50',
        icon: 'text-success',
    },
    IN_PROCESS: { box: 'border-border bg-muted/35', icon: 'text-muted-foreground' },
    IN_REVIEW: { box: 'border-warning-soft-border bg-warning-soft', icon: 'text-warning' },
};

export function PromotionBonusItem({
    kind,
    label,
    amountCents,
    displayStatus,
}: {
    kind: PromotionBonusItemKind;
    label: string;
    amountCents: number;
    displayStatus: PromotionBonusDisplayStatus;
}) {
    const tone = TONE[displayStatus];
    return (
        <li
            data-testid="closing-bonus"
            data-kind={kind}
            data-status={displayStatus}
            className={`flex items-center gap-2.5 rounded-[10px] border px-3 py-2 text-[12.5px] ${tone.box}`}
        >
            <Gift className={`size-4 flex-none ${tone.icon}`} aria-hidden />
            <span className="min-w-0 flex-1 font-medium">{label}</span>
            {displayStatus === 'PAID' && (
                <span className="font-semibold text-success tabular-nums">
                    +{formatMXN(amountCents / 100)}
                </span>
            )}
        </li>
    );
}
